import { SearchIcon } from 'assets/icons';
import { appSettings } from 'config/app.settings';
import React, { useRef, useState } from 'react';

import * as S from './search.styles';

export const Search = () => {
  const [value, setValue] = useState('');
  const inputEl = useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    inputEl?.current?.focus();
  }, [inputEl]);

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (value) {
      window.location.href = `${appSettings.ENV_ZIGGO_URL}/zoeken/?q=${encodeURI(value)}`;
    }
  };

  return (
    <S.Form onSubmit={onSubmit}>
      <S.SearchContainer>
        <S.SearchWrapper>
          <S.Search ref={inputEl} onChange={(e) => setValue(e.target.value)} data-testid="search-input" />
          <S.Button type="submit">
            <SearchIcon />
          </S.Button>
        </S.SearchWrapper>
      </S.SearchContainer>
    </S.Form>
  );
};
